/* Which Triton faces belong on a "this service isn't on yet" pitch. Pure so
   the rule is testable: the pitch names the roles it wants; when a client has
   none of them assigned it still shows whoever IS assigned rather than an
   empty row. No contact details — clients already know how to reach their
   team, and the card just names who to ask. */

export interface PitchMember { role: string; name: string; imageUrl: string }

export function pickPitchTeam<T extends PitchMember>(team: readonly T[], roles: readonly string[], max = 3): T[] {
  const wanted = roles.map((r) => team.find((m) => m.role === r)).filter((m): m is T => !!m);
  const seen = new Set(wanted.map((m) => m.name));
  const chosen = wanted.filter((m, i) => wanted.findIndex((x) => x.name === m.name) === i);
  if (chosen.length >= max) return chosen.slice(0, max);
  for (const m of team) {
    if (chosen.length >= max) break;
    if (!seen.has(m.name)) { chosen.push(m); seen.add(m.name); }
  }
  return chosen;
}

/* Who the card tells the client to ask: the Account Manager when one is
   assigned, otherwise the first person shown. */
export function pitchContact<T extends PitchMember>(shown: readonly T[]): T | null {
  return shown.find((m) => m.role === 'Account Manager') ?? shown[0] ?? null;
}
